import loanApplicationSchema from "../hooks/useNbiForm";

export const validateLoanApplicationField = (
  value: string | undefined,
  field: string
): string | undefined => {
  try {
    const applicantSchema =
      loanApplicationSchema.shape.applicants._def.innerType;

    if (!(field in applicantSchema.element.shape)) {
      console.error(`Field "${field}" does not exist in applicant schema.`);
      return undefined;
    }

    const fieldSchema =
      applicantSchema.element.shape[
        field as keyof typeof applicantSchema.element.shape
      ];

    const result = fieldSchema.safeParse(value?.trim());
    if (!result.success) {
      return result.error.errors.map((e) => e.message)[0];
    }

    return undefined;
  } catch (error) {
    console.error("Failed to read validator schema: ", error);
    return undefined;
  }
};

export const getAllLoanAmountsFieldsErrors = (form: any) => {
  try {
    const result = loanApplicationSchema.shape.amounts.safeParse(
      form.state.values.amounts
    );

    if (!result.success) {
      return result.error.errors || []
    }

    return [];
  } catch (error) {
    console.error("Failed to validate field: ", error);
    return [];
  }
};

export const validateLoanAmountsFields = (form: any, field: string) => {
  try {
    return getAllLoanAmountsFieldsErrors(form).find((e) => e.path.includes(field))?.message;
  } catch (error) {
    console.error("Failed to validate field: ", error);
    return undefined;
  }
};
